import { render } from "./ReferencePopup.vue?vue&type=template&id=b1439f8e&scoped=true"
import script from "./ReferencePopup.vue?vue&type=script&lang=js"
export * from "./ReferencePopup.vue?vue&type=script&lang=js"

import "./ReferencePopup.vue?vue&type=style&index=0&id=b1439f8e&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1439f8e"]])

export default __exports__